/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum RateFuelUnitOfMeasure {
    PerMile = 77,
    PercOfLH = 80,
    PerMileNoTable = 78,
    PercOfLHNoTable = 81,
    NLMBlendedFSC = 66,
    TruckClass = 84,
}
